import React, { Component, Fragment } from "react";
import { observer } from "mobx-react";

import Loading from "@/components/loading";
import Empty from "./empty";
import Equip from "./equip";
import Power from "./power";
import Property from "./property";
import Skill from "./skill";
import Store from "@/stores";

@observer
class Hero extends Component {
	render() {
		const { hero, heroLoading } = Store._ladderStore;
		if (heroLoading) return <Loading />;
		if (!hero) return <Empty />;
		return (
			<Fragment>
				<Equip />
				<div className="ladder-table clearfix center">
					<Property />
					<Skill />
				</div>
				<Power />
			</Fragment>
		);
	}
}
export default Hero;